// To generate a new file similar to this one, run `pay js:run gql-v1 --type=fragment --name=<name> --dir=path/to/dir`.
// You can freely edit this file. To update the generated types, run `eslint` in `--fix` mode.
// Do not delete this comment. https://go/gql-operation-definition

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {SharedToken} from '@stripe-internal/data-v1/types';

import type {
  Exact,
  OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionNetworkEnum,
  OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionProviderEnum,
  OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionTypeEnum,
  OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionVerificationStateEnum,
  OpenapiCryptocurrencyPayinsResourceCryptoSetupSessionStateEnum,
  OpenapiCryptocurrencyPayinsResourceSupportedCurrencyAssetCodeEnum,
  OpenapiCryptocurrencyPayinsResourceSupportedCurrencyCurrencyNetworkEnum,
  Scalars,
} from '@stripe-internal/data-v1/schema/types';

const doc = gql`
  fragment SetupSessionFragment on OpenapiCryptocurrencyPayinsResourceCryptoSetupSession {
    id
    livemode
    merchant
    consumer_account
    state
    payment_mandate {
      fpmandate_id
      return_url
    }
    feature_flags {
      enable_crypto_payins_off_session_payments
      use_async_confirmation_flow
      enable_crypto_payins_pay_from_exchange
      enable_crypto_payins_direct_deposit
      enable_gasless_v2
      enable_smart_contract_wallet_detection
    }
    supported_currencies {
      id
      asset_display_name
      asset_code
      currency_minor_units
      currency_symbol
      currency_network
      mainnet
      contract_address
      chain_id
    }
    business_name
    logo_url
    client_secret
    disabled_wallet_providers
    spender_contract_addresses
    wallet_sessions {
      id
      livemode
      merchant
      address
      connected
      network
      provider
      type
      verification_state
      challenge {
        domain
        address
        uri
        version
        chain_id
        nonce
        issued_at
        scheme
        statement
        expiration_time
        not_before
        request_id
        resources
      }
    }
    active_wallet {
      id
      livemode
      merchant
      address
      connected
      network
      verification_state
      challenge {
        domain
        address
        uri
        version
        chain_id
        nonce
        issued_at
        scheme
        statement
        expiration_time
        not_before
        request_id
        resources
      }
    }
    consumer_wallet
    valid_before
    merchant_branding {
      background_color
      button_color
    }
  }
`;

export const setupSessionFragment: SetupSessionFragmentDocument = doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type SetupSessionFragmentData = {
  readonly __typename: 'OpenapiCryptocurrencyPayinsResourceCryptoSetupSession';
  readonly id: string;
  readonly livemode: boolean;
  readonly merchant: string;
  readonly consumer_account: string | null;
  readonly state: OpenapiCryptocurrencyPayinsResourceCryptoSetupSessionStateEnum;
  readonly business_name: string | null;
  readonly logo_url: string | null;
  readonly client_secret: string;
  readonly disabled_wallet_providers: ReadonlyArray<string> | null;
  readonly spender_contract_addresses: Scalars['JSONObject'] | null;
  readonly consumer_wallet: string | null;
  readonly valid_before: string;
  readonly payment_mandate: {
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourcePaymentMandate';
    readonly fpmandate_id: string;
    readonly return_url: string;
  };
  readonly feature_flags: {
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourceCryptoPayinsFlags';
    readonly enable_crypto_payins_off_session_payments: boolean;
    readonly use_async_confirmation_flow: boolean;
    readonly enable_crypto_payins_pay_from_exchange: boolean;
    readonly enable_crypto_payins_direct_deposit: boolean;
    readonly enable_gasless_v2: boolean;
    readonly enable_smart_contract_wallet_detection: boolean;
  };
  readonly supported_currencies: ReadonlyArray<{
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourceSupportedCurrency';
    readonly id: string;
    readonly asset_display_name: string;
    readonly asset_code: OpenapiCryptocurrencyPayinsResourceSupportedCurrencyAssetCodeEnum;
    readonly currency_minor_units: number;
    readonly currency_symbol: string | null;
    readonly currency_network: OpenapiCryptocurrencyPayinsResourceSupportedCurrencyCurrencyNetworkEnum;
    readonly mainnet: boolean;
    readonly contract_address: string;
    readonly chain_id: number;
  }>;
  readonly wallet_sessions: ReadonlyArray<{
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourceConsumerWalletSession';
    readonly id: string;
    readonly livemode: boolean;
    readonly merchant: string;
    readonly address: string;
    readonly connected: boolean;
    readonly network: OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionNetworkEnum;
    readonly provider: OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionProviderEnum | null;
    readonly type: OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionTypeEnum | null;
    readonly verification_state: OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionVerificationStateEnum;
    readonly challenge: {
      readonly __typename: 'OpenapiCryptocurrencyPayinsResourceWalletVerificationChallenge';
      readonly domain: string;
      readonly address: string;
      readonly uri: string;
      readonly version: string;
      readonly chain_id: number;
      readonly nonce: string;
      readonly issued_at: string;
      readonly scheme: string | null;
      readonly statement: string | null;
      readonly expiration_time: string | null;
      readonly not_before: string | null;
      readonly request_id: string | null;
      readonly resources: ReadonlyArray<string> | null;
    };
  }>;
  readonly active_wallet: {
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourceConsumerWalletSession';
    readonly id: string;
    readonly livemode: boolean;
    readonly merchant: string;
    readonly address: string;
    readonly connected: boolean;
    readonly network: OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionNetworkEnum;
    readonly verification_state: OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionVerificationStateEnum;
    readonly challenge: {
      readonly __typename: 'OpenapiCryptocurrencyPayinsResourceWalletVerificationChallenge';
      readonly domain: string;
      readonly address: string;
      readonly uri: string;
      readonly version: string;
      readonly chain_id: number;
      readonly nonce: string;
      readonly issued_at: string;
      readonly scheme: string | null;
      readonly statement: string | null;
      readonly expiration_time: string | null;
      readonly not_before: string | null;
      readonly request_id: string | null;
      readonly resources: ReadonlyArray<string> | null;
    };
  } | null;
  readonly merchant_branding: {
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourceMerchantBranding';
    readonly background_color: string | null;
    readonly button_color: string | null;
  } | null;
};

export type SetupSessionFragmentVariables = Exact<{[key: string]: never}>;

export type SetupSessionFragmentToken = SharedToken<{}>;

// Temporarily duplicating the token type to facilitate migration.
// This will be removed as part of go/rename-permissions-to-token work.
export type SetupSessionFragmentPermissions = SetupSessionFragmentToken;

export type SetupSessionFragmentDocument = GraphQlDocument<
  SetupSessionFragmentData,
  SetupSessionFragmentVariables,
  SetupSessionFragmentToken
>;
